// extracted by mini-css-extract-plugin
export default {"zoomModal":"IZ-z","image":"JZ-z","button":"KZ-z","isOverlayShown":"LZ-z"};